import axios from "axios";
import { BASE_API_URL } from "../utils/api-url";

export async function getCustomers(accessToken) {
  const result = await axios.get(`${BASE_API_URL}/customers/50000/1`, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });

  return result.data;
}

export async function getCustomersByZone(accessToken, zonesIds) {
  const result = await axios({
    method: "POST",
    url: `${BASE_API_URL}/customers/zones`,
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
    data: { zonesIds },
  });

  return result.data;
}
